import { createSelector } from 'reselect';

export const notificationSelector = createSelector(
  (state) => state.notification,
  (notification) => notification
);
